module.exports = __webpack_public_path__ + "img/bank-bni.20623bc9.png";